import { merge } from "lodash";
import { POLL_TYPE } from "./../wix-rich-content-common";
import { biStrategy } from "./biStrategy/biStrategy";
import iframeSandboxDomainStrategy from "./iframeSandboxDomainStrategy/iframeSandboxDomainStrategy";
import pollsStrategy from "./pollsStrategy/pollsStrategy";
import {
  hasPlugin as hasPluginInPlugins,
  hasPollsPluginInContent,
  parseInstance
} from "./services";
import urlResolutionStrategy from "./urlResolutionStrategy/urlResolutionStrategy";
let getHttpClientPromise;
let httpClientPromise;
const runStrategies = ({
  experiments = {},
  plugins,
  instance,
  wixRicosVersion,
  ricosVersion,
  biSettings,
  httpClient,
  msid = "",
  viewer = false,
  content
}) => {
  const hasPlugin = (pluginType) => hasPluginInPlugins(pluginType, plugins);
  const { metaSiteId: instanceMsid, appDefId } = parseInstance(instance);
  const metaSiteId = instanceMsid || msid;
  getHttpClientPromise = () => {
    if (!httpClientPromise) {
      httpClientPromise = httpClient && Promise.resolve(httpClient) || import(
        /* webpackChunkName: "wix-ricos-http-client-fallback" */
        "@wix/http-client"
      ).then(
        (http) => new http.HttpClient()
      );
    }
    return httpClientPromise;
  };
  const { ricosFeatures, wixRicosFeatures } = experiments;
  const shouldUsePollStrategy = hasPlugin(POLL_TYPE) && (!viewer || viewer && hasPollsPluginInContent(content));
  return merge(
    { experiments: ricosFeatures },
    biStrategy(appDefId, metaSiteId, wixRicosVersion, ricosVersion, biSettings, wixRicosFeatures),
    urlResolutionStrategy(hasPlugin, instance, metaSiteId, wixRicosFeatures),
    shouldUsePollStrategy && pollsStrategy(instance, getHttpClientPromise),
    iframeSandboxDomainStrategy(metaSiteId, wixRicosFeatures),
    wixRicosFeatures
  );
};
const runStrategiesWithCommonUtils = (props) => ({
  strategies: runStrategies(props),
  getHttpClientPromise
});
export {
  runStrategies,
  runStrategiesWithCommonUtils
};
//# sourceMappingURL=runStrategies.js.map
